import React from 'react';
import OverviewTable from '../../../components/Table/ChangeHistoryOverviewTable';

const columnDefinition = [
  { id: 'id', label: 'Änderungsnr.' },
  { id: 'changeDetails', label: 'Details' },
  { id: 'dateAndTime', label: 'Datum und Uhrzeit' },
];

function SkidataChangeHistoryTable({ changeHistory }) {
  return (
    <OverviewTable
      data={changeHistory}
      hover={false}
      columnDefinition={columnDefinition}
    />
  );
}

export default SkidataChangeHistoryTable;



// WEBPACK FOOTER //
// ./src/views/skidata/components/SkidataChangeHistoryTable.jsx